exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Modal {\r\n    z-index:200;\r\n    position: fixed;\r\n    left:40%;\r\n    top:10%;\r\n    /* left: calc(50% - 250px); */\r\n\r\n    /* z-index: 500; */\r\n    /* background-color: white; */\r\n    /* width: 70%; */\r\n    /* border: 1px solid #ccc;\r\n    box-shadow: 1px 1px 1px black; */\r\n    /* padding: 16px; */\r\n    /* left: 35%;\r\n    top: 14%; */\r\n    /* box-sizing: border-box; */\r\n    transition: all 0.3s ease-out;\r\n}\r\n\r\n", ""]);

// exports
